const apiBaseUrl = process.env.REACT_APP_API_BACKEND_URL; // The API base URL
const mediaBaseUrl = process.env.REACT_APP_MEDIA_BACKEND_URL; // The media base URL
const frontendBaseUrl = process.env.REACT_APP_FRONTEND_URL;

export { apiBaseUrl, mediaBaseUrl, frontendBaseUrl };
